module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section04_03_american-village-b999b310046f528c28c17520457e05cb.jpg";